import { useRouter } from "next/router";
import { RaffleForm } from "../raffle/RaffleForm";

export function NewRaffle() {
  const router = useRouter();

  return (
    <div className="mx-auto max-w-xl py-16">
      <h1 className="mx-4 mb-6 font-bitter text-4xl font-semibold">
        New Raffle
      </h1>

      <RaffleForm onSuccess={(cid) => router.push(`/create/${cid}`)} />
    </div>
  );
}
